// src/pages/Dashboard.js
import { useEffect, useState } from 'react';

function SpotifyDashboard() {
  const [playlists, setPlaylists] = useState([]);
  const token = localStorage.getItem('access_token');
  useEffect(() => {
    if (!token) return;

    fetch('https://api.spotify.com/v1/me/playlists', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        setPlaylists(data.items || []);
      });
  }, [token]);

  if (!token) return <p>Please log in</p>;

  return (
    <div>
      <h1>Your Spotify Playlists</h1>
      <ul>
        {playlists.map(pl => (
          <li key={pl.id}>
            <img src={pl.images[0]?.url} alt="" width="100" />
            <strong>{pl.name}</strong> — {pl.tracks.total} tracks
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SpotifyDashboard;
